export default __webpack_public_path__ + "061e4567f0f67f400d4e5b4876371781.png";